import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mx-auto max-w-3xl p-2 text-left" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Images from the on-chain asset provider.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProviderView = _resolveComponent("ProviderView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, " Images from TypeScript prototype. " + _toDisplayString(_ctx.$t("message.touchToUpdate")), 1),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateImages && _ctx.updateImages(...args)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
        return (_openBlock(), _createElementBlock("img", {
          key: image,
          src: image,
          class: "mr-1 mb-1 inline-block w-20"
        }, null, 8, _hoisted_3))
      }), 128))
    ]),
    _hoisted_4,
    _createVNode(_component_ProviderView, { assetProvider: "snow" }),
    _createVNode(_component_ProviderView, { assetProvider: "snowArt" })
  ]))
}